import React from "react";
import { Box, Typography, Card, CardContent, Button } from "@mui/material";
import { Cancel as NotBilledIcon, Warning as WarningIcon } from "@mui/icons-material";
import { motion } from "framer-motion";

const NotBilledSchools = () => {
  return (
    <Box>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
          <NotBilledIcon sx={{ fontSize: 40, color: "warning.main" }} />
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700 }}>
              Not Billed Schools
            </Typography>
            <Typography variant="body1" sx={{ color: "text.secondary" }}>
              Schools that need billing action
            </Typography>
          </Box>
        </Box>
        <Card sx={{ mb: 3, bgcolor: "warning.light", color: "warning.contrastText" }}>
          <CardContent>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  Action Required
                </Typography>
                <Typography variant="body2">
                  Follow up with schools that haven't been billed. Send invoices and payment reminders.
                </Typography>
              </Box>
              <Button variant="contained" sx={{ bgcolor: "white", color: "warning.main", "&:hover": { bgcolor: "grey.100" } }}>
                Send Reminders
              </Button>
            </Box>
          </CardContent>
        </Card>
        <Typography variant="body1" sx={{ color: "text.secondary", textAlign: "center", py: 4 }}>
          Not billed schools list - Filtered view of Schools component
        </Typography>
      </motion.div>
    </Box>
  );
};

export default NotBilledSchools;

